import types from './types';
import {
  GET_INVENTORY_INITIAL_DATA,
  SAVE_INVENTORY_OR_OPEN_CONFIRMATION_MODAL_SUCCESS,
  SAVE_INVENTORY_OR_OPEN_CONFIRMATION_MODAL_FAILURE,
} from '../inventories/types';
import {
  GET_CHEMICAL_PRODUCT_INITIAL_DATA,
  SAVE_CHEMICAL_PRODUCT_OR_OPEN_CONFIRMATION_MODAL_SUCCESS,
  SAVE_CHEMICAL_PRODUCT_OR_OPEN_CONFIRMATION_MODAL_FAILURE,
} from '../chemicalProducts/types';
import { RESET_DETAILS } from '../genericDetails/types';

const defaultState = {
  open: false,
  markAsChecked: false,
  processedChangesNotification: null,
  recipients: [],
  isLoading: false,
};

export default (
  state = defaultState,
  {
    type,
    params,
    request /* using takeQuery: the initier action is set here */,
    data /* using takeQuery: query result will be set here */,
    ...action
  }
) => {
  switch (type) {
    case RESET_DETAILS:
    case GET_INVENTORY_INITIAL_DATA:
    case GET_CHEMICAL_PRODUCT_INITIAL_DATA:
    case SAVE_INVENTORY_OR_OPEN_CONFIRMATION_MODAL_FAILURE:
    case SAVE_CHEMICAL_PRODUCT_OR_OPEN_CONFIRMATION_MODAL_FAILURE:
      return { ...defaultState };

    case types.TOGGLE_SAVE_INVENTORY_MODAL:
      return {
        ...state,
        open: action.state,
        processedChangesNotification: null,
        recipients: [],
        markAsChecked: false,
        isLoading: false,
      };

    case types.UPDATE_PROCESSED_CHANGES_NOTIFICATION:
      return {
        ...state,
        processedChangesNotification: action.processedChangesNotification,
        recipients: action.recipients,
        isLoading: true
      };
    case types.SET_MARK_AS_CHECKED:
      return {
        ...state,
        markAsChecked: action.markAsChecked
      };

    case SAVE_INVENTORY_OR_OPEN_CONFIRMATION_MODAL_SUCCESS:
    case SAVE_CHEMICAL_PRODUCT_OR_OPEN_CONFIRMATION_MODAL_SUCCESS:
      return {
        ...state,
        open: data.openConfirmationModal,
        markAsChecked: false,
        isLoading: !data.openConfirmationModal,
        processedChangesNotification: data.processedTemplateBody,
        recipients: data.recipients,
        skippedInventories: data.skippedInventories,
        batchAllNoOp: data.batchAllNoOp
      };

    default:
      return state;
  }
};
